export default __webpack_public_path__ + "static/media/side-logo.f1950b17.svg";